import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      listStyleType: 'none',
    },
  },
  {
    name: 'ImageWithTextList',
  },
);

export default useStyles;
